import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { LoginGoogleUserApi } from "../../Code/Data"

export default function GoogleLogin({ onSuccess, onFailure }) {

  /**
   * Receives the response from Google and uses it to login the user - 
   * either by finding an account with the Googe "sub" [user id],
   * or with the email address, or if the account is not found, a new account is created
   * and associated with this Google login user account.
   * @param {*} response The encoded JSON response from Google 
   */
  const onGoogleCredentialResponse = async response => {
    const credential = decodeJwtResponse(response.credential);
    if (!!credential) {
      const { Succeeded, ErrorMessage, User } = await LoginGoogleUserApi({
        ...credential
      })
      if (Succeeded && !!User && !!onSuccess) {
        onSuccess(User);
      } else if (!Succeeded || !!ErrorMessage) {        
        console.error("Google login failed.", ErrorMessage);
        if (!!onFailure) {
          onFailure(ErrorMessage);
        }
      }
    }
    else {
      if (!!onFailure) {
        onFailure(response);
        console.error("Google login failed.", response);
      }
    }
  };
  
  useEffect(() => {
    // This is a workaround for React, that assures that the onGoogleCredentialResponse function is available in the global scope
    // when the Google script loads and calls it. 
    window.onGoogleCredentialResponse = onGoogleCredentialResponse;
  });

  return <>
    <Helmet>
      <script src="https://accounts.google.com/gsi/client" async></script>
    </Helmet>
    <div id="g_id_onload"
      data-client_id="798071869437-qfmbkjjkj7qb1e07i8p1ke1jobvajdms.apps.googleusercontent.com"
      data-context="signin"
      data-ux_mode="popup"
      data-callback="onGoogleCredentialResponse"
      data-auto_select="true"
      data-itp_support="true">
    </div>
    <div className="g_id_signin"
      data-type="standard"
      data-shape="pill"
      data-theme="filled_blue"
      data-text="signin_with"
      data-size="medium"
      data-locale="en-US"
      data-logo_alignment="left">
    </div>
  </>
}

const decodeJwtResponse = (token) => {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}
